import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  Row,
  Col,
  Card,
  CardBody,
  Form,
  UncontrolledAccordion,
  Badge,
  Label, Input,
  Button
} from "reactstrap";
import { get, post } from "../../helpers/api_helper";
import { SHOW_ACTIVITY_LOGS } from "helpers/api_endpoints";
import { Trans } from 'react-i18next';
import Select from "react-select";
import { getAction, getUser } from "./logUtils";

document.title = "Activity logs";

const OrderLogs = () => {
  const [loading, setLoading] = useState(false);
  const [orderId, setOrderId] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [data, setData] = useState([]);
  const [actionName, setActionName] = useState("");
  const [response, setResponse] = useState("");

  const actions = [
    {label: 'Create', value: 'add'},
    {label: 'Show', value: 'show'},
    {label: 'Modify', value: 'update'},
    {label: 'Search', value: 'search'},
  ]


  // useEffect(() => {
  //   // setLoading(true);
  //   processLog();
  // }, [orderDate, orderTime]);

  const processLog = () => {
    try {
      post(SHOW_ACTIVITY_LOGS, {type: `api/orders`, action: actionName, id: orderId, dateFrom, dateTo}).then(response => {
        setData(response.data);
        // setColDesciption(response.log.description);
        setLoading(false);
      })     
    }
    catch(error) {
      console.log('logger error', error);
      setLoading(false);
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Order Logs" breadcrumbItem="Order Logs" />
          <Label className="form-label">Response : <Trans>{response}</Trans></Label>
            <Row>
              <Col xl={12}>
                <Card>
                  <CardBody>
                    <Row>
                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>From Date</Trans>
                        </Label>
                        <Input
                          name="dateFrom"
                          value={dateFrom}
                          className="form-control"
                          placeholder="Enter "
                          type="date"
                          onChange={e => setDateFrom(e.target.value)}
                          required
                        ></Input>
                      </div>

                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>To Date</Trans>
                        </Label>
                        <Input
                          name="dateTo"
                          value={dateTo}
                          className="form-control"
                          placeholder="Enter "
                          type="date"
                          onChange={e => setDateTo(e.target.value)}
                          required
                        ></Input>
                      </div>

                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Action</Trans>
                        </Label>
                        <Select
                          name="actionName"
                          value={
                              actions.find(el => el.value === actionName)
                          }
                          options={actions}
                          className="form-control select2"
                          onChange={e => setActionName(e.value)}
                        />
                      </div>

                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Order Id</Trans>
                        </Label>
                        <Input
                          name="id"
                          value={orderId}
                          className="form-control"
                          placeholder="Enter Order Id"
                          type="text"
                          onChange={e => setOrderId(e.target.value)}
                          required
                        ></Input>
                      </div>

                    </Row>
                    <div className="mt-4">
                      <Button
                        type="button"
                        color="danger"
                        onClick={processLog}
                        disabled={loading}
                      >
                        <Trans>{loading ? "Processing..." : "Submit"}</Trans>
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>

          <Form>

            <Row>
              <Col xl={12}>
                <Card>
                  <CardBody>
                    {loading ? (
                      <div className="text-center">
                        {/* <Spinner color="primary" /> */}
                        <span className="ms-2">Loading logs... {loading}</span>
                      </div>
                    ) :
                      data?.map((el, i) => (
                        <UncontrolledAccordion key={i} stayOpen>
                          <Row>
                            <div className="text-center">
                              <b><span className="ms-2">{el?.createdAt.replace('T', ' - ')}</span></b>
                            </div>
                            <div className="" style={{backgroundColor:'#ccf'}}>
                              <h5>{actionName.label}</h5>
                              <h4>By: <Badge className="bg-danger">{getUser(el?.userInfo)}</Badge></h4>
                              <h4>Action: <Badge className="bg-success">{getAction(el?.url)}</Badge></h4>
                              <p>{el.request}</p>
                              
                            </div>
                          </Row>
                        </UncontrolledAccordion>
                      ))
                    
                  }
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </React.Fragment>
  );
};

export default OrderLogs;